import { type ChatTransactionProperties_transaction_OrganizationTransaction as Transaction } from "./chat_transaction_query.graphql";

export enum ZendeskTagField {
  BUNDLE_ID = "bundle_id",
  TRANSACTION_ID = "transaction_id",
  TRANSACTION_SENDER_ID = "transaction_sender_id",
  TRANSACTION_PARTICIPANT = "transaction_participant",
  TRANSACTION_ORG = "transaction_org",
  TRANSACTION_ORG_ID = "transaction_org_id",
  USER_ID = "user_id",
  USER_ORG = "user_org",
  USER_ORG_ID = "user_org_id",
  VIEW = "view",
}
export type ZendeskParticipant = "sender_signer" | "sender" | "signer" | null;
type ParticipantProps = { transaction: Transaction | null; userId: string | null };

function idFromPath(pathTokens: string[], regEx: RegExp, fallBack: string | null) {
  const idMatch = pathTokens.find((t) => regEx.test(t));
  return idMatch || fallBack;
}
export function idsFromURL(pathTokens: string[], search: string) {
  const params = new URLSearchParams(search);
  const bundleIdRegEx = /db.{8}-.{4}-.{4}-.{4}-.{12}/i;
  const transactionIdRegEx = /ot.{7}/i;
  const bundleId = idFromPath(pathTokens, bundleIdRegEx, params.get("bundle_id"));
  const transactionId = idFromPath(pathTokens, transactionIdRegEx, params.get("transaction_id"));
  return { bundleId, transactionId };
}

export function AddZendeskTag(tags: string[], field: ZendeskTagField, val: string | null) {
  val && tags.push(`${field}:${val}`);
}

function userIsSender({ transaction, userId }: ParticipantProps): boolean {
  return Boolean(userId && transaction?.employee.id === userId);
}
function userIsSigner({ transaction, userId }: ParticipantProps): boolean {
  return Boolean(userId && transaction?.customerSigners.find((cs) => cs.userId === userId));
}
export function TransactionParticipant(props: ParticipantProps): ZendeskParticipant {
  if (userIsSender(props)) {
    if (userIsSigner(props)) {
      return "sender_signer";
    }
    return "sender";
  } else if (userIsSigner(props)) {
    return "signer";
  }
  return null;
}
